module.exports = __webpack_public_path__ + "static/media/monograma_flyid.df6dcd64.png";